"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class IconLabel extends _react.default.Component {
  render() {
    const name = this.props.name;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-label": name,
      name: name
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-name",
      title: 'icon-name'
    }, name), /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-image",
      title: 'icon-image'
    }, this.props.children));
  }
}
exports.default = IconLabel;
//# sourceMappingURL=icon-label.js.map